import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";

export const Brand = ({ size = "md" }) => (
  <span className="flex items-center gap-3">
    <img
      src="/nalura-logo.jpg"
      alt="Logo NALURA"
      className={`${size === "lg" ? "w-14 h-14" : "w-10 h-10"} object-contain mix-blend-multiply`}
    />
    <span>
      <span className={`font-display ${size === "lg" ? "text-3xl" : "text-2xl"} tracking-tight text-[#211B10] leading-none block`}>
        NALURA<span className="text-[#A67C1E]">.</span>
      </span>
      <span className="font-mono text-[8px] uppercase tracking-[0.28em] text-[#A67C1E] block mt-1 whitespace-nowrap">
        Good Mind Good Life
      </span>
    </span>
  </span>
);

const links = [
  { href: "/#manifesto", label: "Manifesto", testid: "nav-manifesto-link" },
  { href: "/#tentang", label: "Tentang", testid: "nav-about-link" },
  { href: "/#produk", label: "Produk", testid: "nav-products-link" },
  { href: "/#testimoni", label: "Testimoni", testid: "nav-testimonials-link" },
  { href: "/#faq", label: "FAQ", testid: "nav-faq-link" },
];

export const Nav = () => {
  const [open, setOpen] = useState(false);

  return (
    <motion.header
      initial={{ y: -60, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
      className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-[#FBF7EE]/85 border-b border-[#211B10]/10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <a href="/" data-testid="nav-logo">
          <Brand />
        </a>
        <nav className="hidden md:flex items-center gap-6 lg:gap-10 mx-6 font-mono text-[11px] uppercase tracking-[0.2em] text-[#211B10]/60">
          {links.map((l) => (
            <a key={l.testid} data-testid={l.testid} href={l.href} className="hover:text-[#A67C1E] transition-colors">
              {l.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <a
            data-testid="nav-cta-button"
            href="/#produk"
            className="hidden md:inline-flex bg-[#A67C1E] text-[#FBF7EE] text-xs font-medium uppercase tracking-[0.15em] px-5 py-2.5 hover:bg-[#211B10] hover:-translate-y-0.5 transition-[background-color,transform] duration-300"
          >
            Lihat Produk
          </a>
          <button
            data-testid="nav-mobile-toggle"
            aria-label={open ? "Tutup menu" : "Buka menu"}
            onClick={() => setOpen((o) => !o)}
            className="md:hidden inline-flex items-center justify-center w-10 h-10 border border-[#211B10]/15 text-[#211B10]/70 hover:text-[#A67C1E] transition-colors"
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            data-testid="nav-mobile-menu"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
            className="md:hidden overflow-hidden border-t border-[#211B10]/10 bg-[#FBF7EE]/95 backdrop-blur-xl"
          >
            <div className="px-6 py-6 flex flex-col gap-5 font-mono text-xs uppercase tracking-[0.25em] text-[#211B10]/70">
              {links.map((l) => (
                <a
                  key={l.testid}
                  data-testid={`mobile-${l.testid}`}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="hover:text-[#A67C1E] transition-colors"
                >
                  {l.label}
                </a>
              ))}
              <a
                data-testid="mobile-nav-cta"
                href="/#produk"
                onClick={() => setOpen(false)}
                className="inline-flex self-start bg-[#A67C1E] text-[#FBF7EE] px-5 py-3 tracking-[0.15em] hover:bg-[#211B10] transition-colors"
              >
                Lihat Produk
              </a>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
